/* istanbul ignore file */
export const getNaam = (
    persoonsgegevensState: any | null,
    fallbackNaam: string
  ): string => {
    if (!persoonsgegevensState) {
      return fallbackNaam;
    }
    let voor = persoonsgegevensState.voorletters?.trim() ?? null;
    if (voor === null || voor === "") voor = persoonsgegevensState.voornamen;
    const achternaam = `${persoonsgegevensState.achternaam}`;
    const voorAchternaam = `${voor} ${persoonsgegevensState.achternaam}`;
    const tussenAchternaam = `${persoonsgegevensState.voorvoegsel} ${persoonsgegevensState.achternaam}`;
    const voorTussenAchternaam = `${voor} ${persoonsgegevensState.voorvoegsel} ${persoonsgegevensState.achternaam}`;
    const defaultNaam = `${fallbackNaam}`;
  
    if (persoonsgegevensState.achternaam && voor && persoonsgegevensState.voorvoegsel) {
      return voorTussenAchternaam;
    }
    if (persoonsgegevensState.achternaam && voor && !persoonsgegevensState.voorvoegsel) {
      return voorAchternaam;
    }
    if (persoonsgegevensState.achternaam && !voor && !persoonsgegevensState.voorvoegsel) {
      return achternaam;
    }
  
    if (persoonsgegevensState.achternaam && !voor && persoonsgegevensState.voorvoegsel) {
      return tussenAchternaam;
    }
  
    return defaultNaam;
  };


  export enum ControleMaandlastOptions {
    BenodigdInkomen = "BenodigdInkomen",
    WerkelijkeLast = "WerkelijkeLast",
  }